module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/core-js/library/modules/$.html.js
// module id = 3102
// module chunks = 0